import { createFileRoute } from "@tanstack/react-router"
import { useEffect } from "react"
import { usePageTitle } from "@/contexts/PageTitleContext.tsx"
import {
  Item,
  ItemActions,
  ItemContent,
  ItemDescription,
  ItemHeader,
  ItemMedia,
  ItemTitle,
} from "@/components/ui/item.tsx"
import WavingHand from "@/assets/waving-hand.svg"
import { CreatePitchButton } from "@/components/CreatePitchButton.tsx"
import { useUser } from "@/contexts/UserContext.tsx"
import { useQuery } from "@tanstack/react-query"
import { pitchesApi } from "@/api/pitches.api.ts"
import { Skeleton } from "@/components/ui/skeleton.tsx"
import { useTranslation } from "react-i18next"

export const Route = createFileRoute("/_protected/")({
  ssr: false,
  component: App,
  beforeLoad: () => {
    window.location.replace("/pitches")
  },
})

function App() {
  const { user, isLoading } = useUser()
  const { setTitle } = usePageTitle()
  const { t } = useTranslation()
  const { data, isLoading: isStatLoading } = useQuery({
    queryKey: ["pitches/getJournalistPitchStats"],
    queryFn: () => pitchesApi.getJournalistPitchStats(user?.id),
    enabled: !!(user && user.id),
    structuralSharing: false,
  })

  useEffect(() => {
    setTitle("Home")
  }, [setTitle])

  return (
    <div className="box-border flex h-full w-full">
      <div className="flex w-full min-w-0 flex-col gap-4 text-sm leading-loose">
        <div>
          <Item variant="muted">
            <ItemMedia variant="icon">
              <img src={WavingHand} width={48} />
            </ItemMedia>
            <ItemContent>
              <ItemTitle className="font-heading text-xl">
                Hello {user && `${user.name}`}!
              </ItemTitle>
              <ItemDescription>What is in your mind today?</ItemDescription>
            </ItemContent>
            <ItemActions>
              <CreatePitchButton />
            </ItemActions>
          </Item>
        </div>
        <div>
          <Item variant="muted">
            <ItemHeader className="font-heading text-lg">
              Your Pitches
            </ItemHeader>
            <ItemContent>
              {(!data && isLoading) || isStatLoading ? (
                <div className="flex w-full flex-col gap-2">
                  <Skeleton className="mb-4 h-8 w-full" />
                  <Skeleton className="h-5 w-full" />
                  <Skeleton className="h-5 w-full" />
                  <Skeleton className="h-5 w-full" />
                </div>
              ) : (
                <div>
                  <div>Submitted Pitches: {data?.result?.submittedPitches}</div>
                  <div>Rejected Pitches: {data?.result?.rejectedPitches}</div>
                  <div>
                    Commissioned Pitches: {data?.result?.commissionedPitches}
                  </div>
                  <div>Approved Pitches: {data?.result?.approvedPitches}</div>
                </div>
              )}
            </ItemContent>
          </Item>
        </div>
      </div>
    </div>
  )
}
